import FingerPrint from 'fingerprintjs';
/* istanbul ignore next */
export function getBrowserFingerprint() {
    const fingerPrint = new FingerPrint().get();

    return fingerPrint;
}
